import React from 'react';
import styled from 'styled-components';
import confettiSvg from './assets/confetti.svg';

export const ConfettiAnimation: React.FC<{
  className?: string;
}> = ({className}) => {
  return <Confetti className={className} />;
};

const Confetti = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: url(${confettiSvg}) no-repeat center/cover;
  transform: scale(0);
  opacity: 0;

  animation-name: explode;
  animation-duration: 1.5s;
  animation-timing-function: ease-in-out;

  @keyframes explode {
    50% {
      transform: scale(100%);
      opacity: 1;
    }

    53%,
    70% {
      transform: scale(93%);
      opacity: 1;
    }

    100% {
      transform: scale(130%);
      opacity: 0;
    }
  }
`;
